import React from 'react'
import { EmailConsumer } from '../../../../context/Email'
import { LoggedOffHeaderLogin } from './LoggedOffHeaderLogin'
import { LoggedInHeaderLogin } from './LoggedInHeaderLogin'
import { isResponseFull } from '../../Email/EmailUtils'

export const HeaderLogin = ({
  emailWidget,
  ecoIdentity,
  leaderboardHeight,
  loginModalElement,
  userMenuElement,
  headerHeight,
  domain
}) => {
  return (
    <EmailConsumer>
      {({ inbox, userInfo }) => {
        const isLoggedIn = isResponseFull(inbox)

        if (isLoggedIn) {
          return (
            <LoggedInHeaderLogin
              emailWidget={emailWidget}
              ecoIdentity={ecoIdentity}
              inbox={inbox}
              userInfo={userInfo}
              leaderboardHeight={leaderboardHeight}
              userMenuElement={userMenuElement}
              headerHeight={headerHeight}
            />
          )
        }

        return (
          <LoggedOffHeaderLogin
            inbox={inbox}
            ecoIdentity={ecoIdentity}
            leaderboardHeight={leaderboardHeight}
            loginModalElement={loginModalElement}
            headerHeight={headerHeight}
            domain={domain}
          />
        )
      }}
    </EmailConsumer>
  )
}
